/**
 * ч.1119 — режим доступу поточного користувача в активному акаунті.
 *
 * `readOnly` — усі його ролі «лише перегляд» (`/auth/me` → `read_only`).
 * Сервер у такому разі відхиляє будь-яку зміну даних; інтерфейс заздалегідь
 * вимикає кнопки дій у документах і показує позначку в шапці.
 *
 * Стор, а не хук із запитом: `DocumentToolbar` — презентаційний компонент і
 * рендериться в тестах без QueryClient. Значення ставить `AppLayout`, який
 * уже тримає відповідь `/auth/me`.
 */
import { create } from 'zustand';

export const READ_ONLY_HINT = 'Ваша роль дозволяє лише перегляд';

interface AccessModeState {
  readOnly: boolean;
  setReadOnly: (value: boolean) => void;
}

export const useAccessMode = create<AccessModeState>((set) => ({
  readOnly: false,
  setReadOnly: (value) => set({ readOnly: value }),
}));
